var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('password-input',{attrs:{"error":_vm.newPasswordErrorValue,"name":_vm.name,"label":_vm.label,"id":_vm.id,"placeholder":_vm.placeholder,"value":_vm.newPasswordValue,"is-required":_vm.isRequired},on:{"input":_vm.validateNewPassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }